import { render } from "./B24ClientAuth.vue?vue&type=template&id=243e00d4&scoped=true"
import script from "./B24ClientAuth.vue?vue&type=script&lang=js"
export * from "./B24ClientAuth.vue?vue&type=script&lang=js"

import "./B24ClientAuth.vue?vue&type=style&index=0&id=243e00d4&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243e00d4"]])

export default __exports__